import React from 'react';
import { Users, CheckSquare, Calendar, FileText, Bell, BarChart2, PieChart } from 'lucide-react';
import { KpiCard } from './ui/KpiCard';
import { AnnouncementCard } from './ui/AnnouncementCard';
import { TabNavigation } from './ui/TabNavigation';
export function Dashboard() {
  const tabs = [{
    icon: Bell,
    label: 'Notifications and Events',
    active: true
  }, {
    icon: Users,
    label: 'Employee Services',
    active: false
  }, {
    icon: CheckSquare,
    label: 'Pending Requests',
    active: false
  }, {
    icon: Calendar,
    label: 'Other Platforms',
    active: false
  }, {
    icon: FileText,
    label: 'General Manager Office',
    active: false
  }];
  const announcements = [{
    id: 1,
    title: 'Circular for annual committee reports',
    icon: Bell
  }, {
    id: 2,
    title: 'Assigning Ms Hiba Ali to Finance Committee',
    icon: Bell
  }, {
    id: 3,
    title: 'Assigning Mrs. Noura to HR Committee',
    icon: Bell
  }, {
    id: 4,
    title: 'Assigning Eng.Shikha Ali to IT Committee',
    icon: Bell
  }, {
    id: 5,
    title: 'Assigning Ms.Nawal Alnaqbi to Procurement Committee',
    icon: Bell
  }];
  return <div data-id="element-1030">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1031">
        <KpiCard title="Active Committees" value="12" icon={Users} color="bg-blue-100" iconColor="text-blue-500" data-id="element-1032" />
        <KpiCard title="Pending Recommendations" value="24" icon={CheckSquare} color="bg-orange-100" iconColor="text-orange-500" data-id="element-1033" />
        <KpiCard title="Upcoming Meetings" value="8" icon={Calendar} color="bg-purple-100" iconColor="text-purple-500" data-id="element-1034" />
        <KpiCard title="Completed Tasks" value="86" icon={FileText} color="bg-green-100" iconColor="text-green-500" data-id="element-1035" />
      </div>
      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1036">
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1037">
          <h3 className="text-lg font-semibold mb-4 flex items-center" data-id="element-1038">
            <BarChart2 size={20} className="mr-2 text-gray-500" data-id="element-1039" />
            Task Completion Rates
          </h3>
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded" data-id="element-1040">
            <p className="text-gray-500" data-id="element-1041">
              Task completion chart will appear here
            </p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1042">
          <h3 className="text-lg font-semibold mb-4 flex items-center" data-id="element-1043">
            <PieChart size={20} className="mr-2 text-gray-500" data-id="element-1044" />
            Active vs Completed Committees
          </h3>
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded" data-id="element-1045">
            <p className="text-gray-500" data-id="element-1046">
              Committee status chart will appear here
            </p>
          </div>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="bg-white p-6 rounded-lg shadow-sm mb-8" data-id="element-1047">
        <h3 className="text-lg font-semibold mb-4" data-id="element-1048">Quick Actions</h3>
        <div className="flex flex-wrap gap-4" data-id="element-1049">
          <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1050">
            Schedule Meeting
          </button>
          <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1051">
            Add Task
          </button>
          <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1052">
            Upload Document
          </button>
        </div>
      </div>
      {/* Tabs and Announcements */}
      <div className="bg-white rounded-lg shadow-sm" data-id="element-1053">
        <TabNavigation tabs={tabs} data-id="element-1054" />
        <div className="p-6" data-id="element-1055">
          <h3 className="text-lg font-semibold mb-4" data-id="element-1056">Announcements</h3>
          <div className="space-y-4" data-id="element-1057">
            {announcements.map(announcement => <AnnouncementCard key={announcement.id} title={announcement.title} icon={announcement.icon} data-id="element-1058" />)}
          </div>
        </div>
      </div>
    </div>;
}